import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "left-menu" }
const _hoisted_4 = { class: "right-content" }
const _hoisted_5 = { class: "content-container" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "org-title" }
const _hoisted_8 = { class: "content-text" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["href"]

import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PdfViewer',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const pdfUrl = ref(route.query.url as string);
const pdfTitle = ref(route.query.title as string);
const activeMenu = computed(() => {
  return route.path;
});

const handleMenuSelect = (index: string) => {
  router.push(index);
};

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "menu-title" }, "党建文化", -1)),
        _createVNode(_component_el_menu, {
          "default-active": activeMenu.value,
          class: "el-menu-vertical",
          onSelect: handleMenuSelect
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "/dangjian" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("span", null, "党建动态", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/dangzhang" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("span", null, "党章党规", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(pdfTitle.value), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("iframe", {
                src: pdfUrl.value,
                width: "100%",
                height: "600px",
                style: {"border":"1px solid #eee","border-radius":"4px"},
                frameborder: "0"
              }, [
                _cache[3] || (_cache[3] = _createTextVNode(" 您的浏览器不支持 PDF 预览，请 ")),
                _createElementVNode("a", {
                  href: pdfUrl.value,
                  target: "_blank"
                }, "点击下载", 8, _hoisted_10),
                _cache[4] || (_cache[4] = _createTextVNode("查看。 "))
              ], 8, _hoisted_9)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})